module.exports = __webpack_public_path__ + "static/media/map_sample.daa73573.png";